import { Currency } from '@/core/currency/interfaces';

const ILS: Currency = {
    name: 'Israeli new Shekel',
    demonym: 'Israeli',
    majorSingle: 'Shekel',
    majorPlural: 'Shekels',
    codeNumeric: '376',
    symbol: '₪',
    symbolNative: '₪',
    minorSingle: 'Agora',
    minorPlural: 'Agoras',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'ILS',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default ILS;
